import { translate } from './index';

const ERROR_KEYS = {
  INVALID_PLAYERS: 'invalidPlayers',
  PLAYER_NOT_FOUND: 'notFound',
  PLAYER_OUTSIDE_CLUB: 'outsideClub',
  CLUB_ACCESS_DENIED: 'forbidden',
  FOREIGN_TOURNAMENT: 'foreignTournament',
  FOREIGN_TEAM: 'foreignTeam',
  FOREIGN_RELATED_DATA: 'foreignRelatedData',
  FIDE_TITLE_CONFLICT: 'titleConflict',
  LOCAL_TITLE_CONFLICT: 'titleConflict',
  ACTIVE_SUBSCRIPTION_CONFLICT: 'subscriptionConflict',
  PAYMENT_SETTING_CONFLICT: 'paymentConflict',
  RATING_SNAPSHOT_CONFLICT: 'ratingConflict',
  SEASON_BONUS_CONFLICT: 'bonusConflict',
  INVALID_IDEMPOTENCY_KEY: 'validation',
  IDEMPOTENCY_KEY_CONFLICT: 'conflict',
  PLAYER_MERGE_IN_PROGRESS: 'mergeInProgress',
  MERGE_BLOCKED: 'mergeBlocked',
  PLAYER_CHANGED: 'dataChanged',
  SERVER_INTERRUPTED: 'interrupted',
  PLAYER_MERGE_FAILED: 'mergeFailed',
  UNSUPPORTED_PLAYER_RELATIONS: 'unsupportedRelations',
  ERR_NETWORK: 'network',
  ECONNABORTED: 'timeout',
  ETIMEDOUT: 'timeout',
};

// Older endpoints return messages without a code. Match only known categories;
// never display an unrecognized server response as user-facing text.
const LEGACY_ERRORS = [
  [/invalid identifier or password|invalid credentials/i, 'credentials'],
  [/account.*blocked|аккаунт.*заблокирован/i, 'forbidden'],
  [/email.*not confirmed/i, 'emailNotConfirmed'],
  [/у игрока уже есть действующий абонемент/i, 'subscriptionConflict'],
  [/уже использовано турниров/i, 'subscriptionLimit'],
  [/выберите вид абонемента|укажите дату окончания|количество турниров должно быть больше нуля/i, 'subscriptionValidation'],
  [/подходящий абонемент недоступен/i, 'subscriptionNotApplicable'],
  [/абонемент.*(ист[её]к|неактивен|законч|исчерпан|больше не действует)|действующий абонемент не найден|недостаточно.*(турнир|остат)/i, 'subscriptionUnavailable'],
  [/можно добавить только заверш[её]нный турнир игрока/i, 'subscriptionTournament'],
  [/такая ссылка уже занята|slug.*(unique|taken)/i, 'slugTaken'],
  [/уже.*(списан|добавлен|учт[её]н|использован в другом турнире)|already.*(deducted|included)/i, 'conflict'],
  [/не найден|not found/i, 'notFound'],
];

export function translateError(error, fallback = translate('errors.actionFailed')) {
  const responseError = error?.response?.data?.error;
  const payload = responseError && typeof responseError === 'object' ? responseError : error;
  const code = payload?.details?.code || payload?.code || error?.code;
  const key = Object.hasOwn(ERROR_KEYS, code) ? ERROR_KEYS[code] : null;
  if (key) return translate(`errors.${key}`);
  if (code === 'PLAYER_ACTIVE_IN_ANOTHER_SLOT') return translate('serviceMessages.playerActiveInAnotherSlot');
  if (code === 'TOURNAMENT_SETTINGS_LOCKED') return translate('tournamentEdit.settingsLockedDetail');

  const message = typeof payload?.message === 'string' ? payload.message : '';
  const legacyKey = LEGACY_ERRORS.find(([pattern]) => pattern.test(message))?.[1];
  if (legacyKey) return translate(`errors.${legacyKey}`);

  const status = Number(error?.response?.status || payload?.status);
  if (status === 401) return translate('errors.unauthorized');
  if (status === 403) return translate('errors.forbidden');
  if (status === 404) return translate('errors.notFound');
  if (status === 409) return translate('errors.conflict');
  if (status === 429) return translate('errors.rateLimit');
  if (status >= 500) return translate('errors.server');
  if (status === 400 || status === 422 || payload?.name === 'ValidationError') return translate('errors.validation');
  return fallback;
}
